import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";


import {SongState} from "./types";

import {Song} from "../../utils/types";
import SongService, {fetchGraphQL, GET_SONGS_QUERY} from "./song_services";

// Create a thunk to fetch songs
export const fetchSongs = createAsyncThunk(
    "songs/fetchSongs",
    async (query:any, {dispatch, rejectWithValue}):Promise<Song[] | any> => {
        try {
            // Make API request
            const data = await SongService.fetchSongs(query);

            // const gql = await fetchGraphQL({query: GET_SONGS_QUERY, variables: { page: 1, limit: 10, genre: 'gospel' }})
            // console.log({gql})

            // Use dispatch to set songs
            dispatch(setSongs(data.data));


            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

// Create a thunk to fetch a song
export const fetchSong = createAsyncThunk(
    "songs/fetchSong",
    async (id: string, {rejectWithValue}) => {
        try {
            // Make API request
            const data = await SongService.fetchSong(id);

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

// Create a thunk to search songs
export const searchSongs = createAsyncThunk(
    "songs/searchSongs",
    async (query: any, {rejectWithValue}) => {
        try {

            // Make API request
            const data = await SongService.searchSongs(query);

            // Return response
            return data.data;
        } catch (error: any) {
            // If server error, throw error
            return rejectWithValue(error.response.data.message || error.message);
        }
    }
);

// Create initial state
const initialState: SongState = {
    songs: [],
    song: null,
    search_results: {},
    loading: false,
    error: null
};


// Create a slice for songs
const songSlice = createSlice({
    name: "songs",
    initialState,
    reducers: {
        // Add reducers here
        setSongs: (state, action) => {
            state.songs = action.payload
        },
        setSong: (state, action) => {
            state.song = action.payload
        }
    },
    extraReducers: (builder) => {
        // Fetch Songs
        builder.addCase(fetchSongs.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSongs.fulfilled, (state, action) => {
            state.loading = false;
            // Set songs to state and also check if payload is new paginated data
            // state.songs = [...state.songs, ...action.payload];
        });
        builder.addCase(fetchSongs.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as any;
        });

        // Fetch Song
        builder.addCase(fetchSong.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(fetchSong.fulfilled, (state, action) => {
            state.loading = false;
            state.song = action.payload;
        });
        builder.addCase(fetchSong.rejected, (state, action) => {
            state.loading = false;
            // TODO: Check if this breaks anything - currently using this to ensure songs from search also get set if initial song isn't from search.
            state.song = null;
            state.error = action.payload as any;
        });

        // Search Songs
        builder.addCase(searchSongs.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(searchSongs.fulfilled, (state, action) => {
            state.loading = false;
            state.search_results = action.payload;
        });
        builder.addCase(searchSongs.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload as any;
        });

       },
});

// Export actions
export const  {setSongs, setSong} = songSlice.actions;

// Export reducer
export default songSlice.reducer;